import axios from 'axios';
import { getBaseUrlSolicitante, ensureProtocol } from '../config/backend';

const REFRESH_MARGIN_MS = 2 * 60 * 1000;
let refreshTimer = null;
let refreshPromise = null;

export function baseUrlSolicitante() {
  return getBaseUrlSolicitante() || ensureProtocol(localStorage.getItem('ipBackend') || '');
}

export function getRawToken() {
  const t = localStorage.getItem('token');
  if (!t) return '';
  return t.startsWith('Bearer ') ? t.slice(7) : t;
}

export function getAuthHeader() {
  const t = localStorage.getItem('token');
  if (!t || !t.trim()) return {};
  return { Authorization: t.startsWith('Bearer ') ? t : 'Bearer ' + t };
}

export function decodeJwt(token) {
  try {
    const raw = token && token.startsWith('Bearer ') ? token.slice(7) : token;
    if (!raw || raw.split('.').length < 2) return null;
    const base64 = raw.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch (_) {
    return null;
  }
}

export function msUntilExpiry(token) {
  const payload = decodeJwt(token || localStorage.getItem('token') || '');
  if (!payload || !payload.exp) return null;
  return payload.exp * 1000 - Date.now();
}

export function persistTokens(data) {
  if (!data) return;
  if (data.token) {
    localStorage.setItem('token', data.token.startsWith('Bearer ') ? data.token : 'Bearer ' + data.token);
  }
  if (data.refreshToken) localStorage.setItem('refreshToken', data.refreshToken);
  if (data.empresa_id != null) localStorage.setItem('empresa_id', data.empresa_id);
  if (data.empresa_nome != null) localStorage.setItem('empresa_nome', data.empresa_nome);
  if (data.ia_habilitada != null) localStorage.setItem('ia_habilitada', String(data.ia_habilitada));
}

export function limparSessao() {
  localStorage.setItem('token', '');
  localStorage.setItem('refreshToken', '');
  localStorage.setItem('codUsu', 0);
  localStorage.setItem('logado', 'N');
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
}

export function refreshAccessToken() {
  if (refreshPromise) return refreshPromise;
  const refreshToken = localStorage.getItem('refreshToken');
  const base = baseUrlSolicitante();
  if (!refreshToken || !base) return Promise.resolve(null);

  refreshPromise = axios
    .post(base + '/api/refresh', { refreshToken }, { timeout: 15000 })
    .then((res) => {
      const data = res?.data;
      if (data && data.token) {
        persistTokens(data);
        agendarRenovacao();
        const t = localStorage.getItem('token');
        return t || null;
      }
      return null;
    })
    .catch(() => null)
    .finally(() => {
      refreshPromise = null;
    });

  return refreshPromise;
}

export function agendarRenovacao() {
  if (refreshTimer) {
    clearTimeout(refreshTimer);
    refreshTimer = null;
  }
  const token = localStorage.getItem('token');
  if (!token || !token.trim()) return;
  if (!localStorage.getItem('refreshToken')) return;

  const ms = msUntilExpiry(token);
  if (ms == null) return;
  const delay = Math.max(5000, ms - REFRESH_MARGIN_MS);
  refreshTimer = setTimeout(() => {
    refreshAccessToken();
  }, delay);
}

export function refreshSeNecessario() {
  const token = localStorage.getItem('token');
  if (!token || !token.trim()) return Promise.resolve(null);
  if (!localStorage.getItem('refreshToken')) return Promise.resolve(null);
  const ms = msUntilExpiry(token);
  if (ms != null && ms <= REFRESH_MARGIN_MS) {
    return refreshAccessToken();
  }
  return Promise.resolve(token);
}

let visibilityHooked = false;

export function iniciarGestaoToken() {
  agendarRenovacao();
  if (!visibilityHooked && typeof document !== 'undefined') {
    visibilityHooked = true;
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        refreshSeNecessario();
      }
    });
  }
}
